import gql from 'graphql-tag';





export const GETBYUSERID = gql(`
query($userId: Int!,$applicationId: Int!,$applicationVersion: Int!,$componentId: Int! ){
    searchConfigQuery{
        getByAllByUserId(userId: $userId, applicationId: $applicationId, applicationVersion: $applicationVersion, componentId: $componentId)
        {            
            userId
            applicationId
            applicationVersion
            componentId
            profileId
            name
            data
            fcr
        }
    }
}
`);
